import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../../../Translations';

export interface Props {
  onClick: () => void;
  buttonText: TPlainTextKey;
}

function SubmitButton({ onClick, buttonText }: Props) {
  return (
    <div
      className={clsx(
        'cursor-pointer rounded-md bg-teal-600 text-white px-3 py-2 text-sm w-24 text-center mt-4',
      )}
      onClick={onClick}
      data-intercom-target="invite-participants-submit-button"
    >
      <T kind={buttonText} />
    </div>
  );
}

export default observer(SubmitButton);
